<template>
    <div class="has-text-centered py-6 px-6" style="background:#F8F9FD">
        <div class="is-flex is-justify-content-center">
            <i
                class="material-icons is-size-2 icon-clear mr-2 has-text-secondary-light"
            >
                info
            </i>
            <p class="has-text-weight-bold is-size-4 has-text-centered mb-4">
                Conecta tus bancos y podrás ver tus movimientos en línea
            </p>
        </div>
        <p class="mb-5">
            Aquí podrás ver de forma automatizada todos los cargos y abonos que
            realices con tus cuentas bancarias.
        </p>
        <b-button type="is-flow" rounded v-on:click="onConnect"
            >Conectar Cuentas Bancarias</b-button
        >
    </div>
</template>

<script>
export default {
    name: "Notification",
    methods: {
        onConnect: function() {
            this.$emit("onConnect");
        },
    },
};
</script>
